import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input } from 'antd';
import { FormWrapper } from 'components/Page';

const FormItem = Form.Item;

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    name
  } = dataSource;

  return {
    name: Form.createFormField({ value: name })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inputFormItemLayout, form
}) => {
  const { getFieldDecorator } = form;
  const {
    name, is_published
  } = dataSource;
  const readonly = !canAdmin || is_published;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Name">
        {getFieldDecorator('name', {
          initialValue: name,
          rules: [{
            required: true,
            message: 'Please enter the Roster name.'
          }]
        })(<Input disabled={readonly} />)}
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inputFormItemLayout: PropTypes.object,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  dataSource: {},
  form: {},
  inputFormItemLayout: {},
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const RosterVersionInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput));

export default RosterVersionInput;
